module.exports = __webpack_public_path__ + "media/images/social-share-button/qq-a629a1a638b10f852767bb500ff0d15d.svg";